import React from "react";
import { Helmet } from "react-helmet-async";

const Seo = ({
    title,
    description,
    canonical,
    image = "https://thrundrz.fr/logo.png",
    type = "website",
    structuredData = null,
    noindex = false,
}) => {
    // 🆕 Accepte un objet OU un tableau de plusieurs schémas
    const schemas = structuredData
        ? Array.isArray(structuredData)
            ? structuredData
            : [structuredData]
        : [];

    return (
        <Helmet>
            <html lang="fr" />

            <title>{title}</title>

            <meta name="description" content={description} />

            {/* 🆕 Permet de désindexer les pages d'erreur */}
            <meta
                name="robots"
                content={noindex ? "noindex, follow" : "index, follow"}
            />

            <link rel="canonical" href={canonical} />

            {/* Open Graph */}
            <meta property="og:type" content={type} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={canonical} />
            <meta property="og:image" content={image} />
            <meta property="og:image:width" content="1200" />
            <meta property="og:image:height" content="630" />
            <meta property="og:locale" content="fr_FR" />
            <meta property="og:site_name" content="Thrundrz" />

            {/* Twitter / X */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image} />

            {/* Structured Data — un script par schéma */}
            {schemas.map((schema, i) => (
                <script key={i} type="application/ld+json">
                    {JSON.stringify(schema)}
                </script>
            ))}
        </Helmet>
    );
};

export default Seo;